if (!customElements.get('collection-image-with-text')) {
  class CollectionImageWithText extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initMobileToggles();
    }

    initMobileToggles() {
      const toggleButtons = this.querySelectorAll('.mobile-toggle-btn');

      if (!toggleButtons.length) return;

      toggleButtons.forEach((button) => {
        const descriptionWrapper = button.closest('.mobile-toggle-description');
        if (!descriptionWrapper) return;

        const descriptionContent = descriptionWrapper.querySelector('.description-content');
        const toggleIcon = button.querySelector('.toggle-icon');

        if (!descriptionContent || !toggleIcon) return;

        descriptionContent.classList.add('collapsed');
        button.setAttribute('aria-expanded', 'false');
        toggleIcon.textContent = '+';

        button.addEventListener('click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';

          if (isExpanded) {
            button.setAttribute('aria-expanded', 'false');
            descriptionContent.classList.remove('expanded');
            descriptionContent.classList.add('collapsed');
            toggleIcon.textContent = '+';
          } else {
            button.setAttribute('aria-expanded', 'true');
            descriptionContent.classList.remove('collapsed');
            descriptionContent.classList.add('expanded');
            toggleIcon.textContent = '−';
          }
        });
      });
    }
  }

  customElements.define('collection-image-with-text', CollectionImageWithText);
}


